import * as types from "../../mutation-types";

const mutations = {
  [types.SET_PERSONS]: (state, payload) => {
    state.persons = payload;
  },
}

export default mutations;
